// extracted by mini-css-extract-plugin
export default {"ResumeCell":"styles_ResumeCell__w+-bu"};